import type { RHFGroupFieldValue } from '@/components/dynamic-filter/FilterFormGroup';
import type { DeviceSKUResponse } from '@/types/apps/device-sku.type';
import type { GqlListResponse } from '@/types/common/api.type';
import { BaseService } from '@/types/service/graphql-service.type';

export interface DeviceSKUGraphQLServiceInterface {}

type DeviceSKUGraphQLListResponse = GqlListResponse<DeviceSKUResponse>;

export class DeviceSKUGraphQLService
    extends BaseService
    implements DeviceSKUGraphQLServiceInterface
{
    public getEntityName(): string {
        return 'deviceSKU';
    }

    public getFields(): Record<string, any> {
        return {
            code: true,
            createdBy: true,
            createdDate: true,
            deletedAt: true,
            deletedBy: true,
            description: true,
            deviceGroupCode: true,
            deviceGroupId: true,
            deviceTypeCode: true,
            deviceTypeId: true,
            id: true,
            isDeleted: true,
            modifiedBy: true,
            modifiedDate: true,
            name: true,
            deviceGroup: {
                name: true,
            },
            deviceType: {
                name: true,
            },
        };
    }

    public async index(query: string): Promise<DeviceSKUGraphQLListResponse> {
        return this.fetchGqlList<DeviceSKUGraphQLListResponse>(
            query,
            this.getEntityName()
        ).then(res => {
            return {
                ...res,
                items: res.items.map(item => ({
                    ...item,
                    customName: `${item.code} - ${item.name}`,
                })),
            };
        });
    }

    public getFilterByRole(): Record<string, RHFGroupFieldValue> {
        if (!this.getQueryById() || !this.getRoleTypeManager().getQuery) {
            return {};
        }

        return this.getRoleTypeManager().getQuery('deviceSKU', {
            userId: this.getQueryById(),
        });
    }
}
